import T from "../../theme";

export const Btn = ({ children, onClick, variant = "primary", disabled = false, style: xs = {} }) => {
  const v = {
    primary:   { background: T.primary,    color: "#fff",     border: "none" },
    secondary: { background: "#fff",        color: "#374151",  border: `1px solid ${T.border}` },
    ghost:     { background: "transparent", color: T.textMuted, border: "none" },
    danger:    { background: T.dangerLight, color: T.danger,   border: "1px solid #fecaca" },
  };

  return (
    <button
      onClick={disabled ? undefined : onClick}
      style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "9px 16px", fontSize: 14, fontWeight: 500, borderRadius: T.radius, cursor: disabled ? "not-allowed" : "pointer", opacity: disabled ? 0.6 : 1, transition: "all 0.15s", ...v[variant], ...xs }}
      onMouseEnter={e => {
        if (!disabled && variant === "primary")   e.currentTarget.style.background = T.primaryHover;
        else if (!disabled && variant === "secondary") e.currentTarget.style.background = "#f9fafb";
        else if (!disabled && variant === "ghost")     e.currentTarget.style.background = "#f3f4f6";
      }}
      onMouseLeave={e => {
        if (variant === "primary")   e.currentTarget.style.background = T.primary;
        else if (variant === "secondary") e.currentTarget.style.background = "#fff";
        else e.currentTarget.style.background = "transparent";
      }}>
      {children}
    </button>
  );
};
